import { Stack, Typography } from '@mui/material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { AggregatedInfoPaper } from '@retail/price-control/components';
import { PriceControlSupplierAggregated } from '@retail/price-control/types';
import { negativeChange } from './PriceControlAggregatedInfo';

interface Props {
  priceControlSupplier?: PriceControlSupplierAggregated;
  isLoadingFetchItems: boolean;
}

export function AggregatedSupplierInfo({ priceControlSupplier, isLoadingFetchItems }: Props) {
  const t = useMyAssortmentTFunction();

  const purchasePriceChanges = priceControlSupplier?.purchasePriceAverageDiffAbsolute;
  const purchasePricePercentChange = priceControlSupplier?.purchasePriceAverageDiffPercentage;
  const salesPricePercentChange = priceControlSupplier?.salesPriceAverageDiffPercentage;
  const averageFactorPercentChanges = priceControlSupplier?.salesFactorAverageDiffPercentage;

  return (
    <Stack
      px={2}
      pt={1}
      flexDirection="row"
      justifyContent="space-between"
      borderBottom={(theme) => `1px solid ${theme.vars.palette.divider}`}
    >
      <AggregatedInfoPaper
        heading={t('myAssortment.levels.supplier').toUpperCase()}
        aggregatedInfo={priceControlSupplier?.supplierName ?? '-'}
        aggregatedAdditionalInfo={
          <Typography variant="subtitle1">{priceControlSupplier?.supplierNumber}</Typography>
        }
        headerSize="small"
        isLoadingFetchItems={isLoadingFetchItems}
      />

      <AggregatedInfoPaper
        heading={t('myAssortment.columns.nrOfItems').toUpperCase()}
        aggregatedInfo={`${priceControlSupplier?.suppliersItemsForPriceControlAmount ?? '-'} /   ${
          priceControlSupplier?.totalItemsFromSupplierInAssortment ?? '-'
        }`}
        aggregatedAdditionalInfo={''}
        headerSize="small"
        isLoadingFetchItems={isLoadingFetchItems}
      />
      <AggregatedInfoPaper
        heading={t('myAssortment.priceControl.averagePurchasePriceChange').toUpperCase()}
        aggregatedInfo={`${
          purchasePricePercentChange && purchasePricePercentChange > 0 ? '+' : ''
        } ${purchasePricePercentChange ?? '-'} %`}
        negativeChange={purchasePriceChanges ? negativeChange(purchasePriceChanges) : undefined}
        headerSize="small"
        isLoadingFetchItems={isLoadingFetchItems}
      />
      <AggregatedInfoPaper
        heading={t('myAssortment.priceControl.averageSalesPriceChange').toUpperCase()}
        aggregatedInfo={`${salesPricePercentChange && salesPricePercentChange > 0 ? '+' : ''} ${
          salesPricePercentChange ?? '-'
        } %`}
        headerSize="small"
        isLoadingFetchItems={isLoadingFetchItems}
      />
      <AggregatedInfoPaper
        heading={t('myAssortment.priceControl.averageFactorChange').toUpperCase()}
        aggregatedInfo={`${
          averageFactorPercentChanges && averageFactorPercentChanges > 0 ? '+' : ''
        } ${averageFactorPercentChanges ?? '-'} `}
        negativeChange={averageFactorPercentChanges ? averageFactorPercentChanges <= 0 : undefined}
        headerSize="small"
        isLoadingFetchItems={isLoadingFetchItems}
      />
    </Stack>
  );
}
